import type { ContributorIdentity, WorkTypeFilter } from '../types';

const RECENT_KEY = 'sw:recent';
const REACTIONS_KEY = 'sw:reactions';
const IDENTITY_KEY = 'sw:identity';
const TYPE_KEY = 'sw:type';

export function storedType(): WorkTypeFilter {
  const value = localStorage.getItem(TYPE_KEY);
  return value === 'movie' || value === 'series' || value === 'anime' ? value : 'all';
}
export function rememberType(value: WorkTypeFilter): void {
  localStorage.setItem(TYPE_KEY, value);
}

export function recentIds(): string[] {
  try { return JSON.parse(localStorage.getItem(RECENT_KEY) || '[]'); } catch { return []; }
}
export function rememberSpoiler(id: string, limit = 50): void {
  localStorage.setItem(RECENT_KEY, JSON.stringify([id, ...recentIds().filter((item) => item !== id)].slice(0, limit)));
}
export function hasReacted(id: string, kind: 'hurt' | 'watch'): boolean {
  try { return Boolean(JSON.parse(localStorage.getItem(REACTIONS_KEY) || '{}')[`${id}:${kind}`]); } catch { return false; }
}
export function markReacted(id: string, kind: 'hurt' | 'watch'): void {
  let value: Record<string, boolean> = {};
  try { value = JSON.parse(localStorage.getItem(REACTIONS_KEY) || '{}'); } catch { /* ignore damaged local data */ }
  value[`${id}:${kind}`] = true;
  localStorage.setItem(REACTIONS_KEY, JSON.stringify(value));
}
export function getIdentity(): ContributorIdentity | null {
  try { return JSON.parse(localStorage.getItem(IDENTITY_KEY) || 'null'); } catch { return null; }
}
export function createIdentity(nickname: string): ContributorIdentity {
  const id = crypto.randomUUID();
  const bytes = crypto.getRandomValues(new Uint8Array(32));
  const token = Array.from(bytes, (byte) => byte.toString(16).padStart(2, '0')).join('');
  const identity = { id, token, nickname };
  localStorage.setItem(IDENTITY_KEY, JSON.stringify(identity));
  return identity;
}
